import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/courier-pickup.svg'


const _hoisted_1 = { class: "flex flex-row gap-x-2" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-10",
  alt: "courier-pickup"
}, null, -1)
const _hoisted_3 = { class: "flex flex-row font-semibold gap-x-2" }
const _hoisted_4 = { class: "text-14px text-gray-lp-500" }
const _hoisted_5 = { class: "text-14px text-gray-lp-300" }
const _hoisted_6 = { class: "flex flex-row font-semibold gap-x-2" }
const _hoisted_7 = { class: "text-14px text-gray-lp-500" }
const _hoisted_8 = { class: "text-14px text-gray-lp-300" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_BarCharts = _resolveComponent("BarCharts")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_ModalV2, {
        key: 0,
        isCustomTitle: true,
        showFooter: false,
        width: "w-6/12",
        onClose: _ctx.onCloseModal
      }, {
        "custom-title": _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode("div", null, [
              _createVNode("div", _hoisted_3, [
                _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("dexAssessmentDashboard.courierLabel")), 1),
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.courierName), 1)
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("dexAssessmentDashboard.totalTicketDexLabel")), 1),
                _createVNode("p", _hoisted_8, _toDisplayString(_ctx.total), 1)
              ])
            ])
          ])
        ]),
        content: _withCtx(() => [
          (_ctx.dashboardData.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode(_component_Skeleton, {
                  class: "mt-2",
                  height: "1rem"
                }),
                _createVNode(_component_Skeleton, {
                  class: "mt-2",
                  height: "20rem"
                })
              ]))
            : (_openBlock(), _createBlock(_component_BarCharts, _mergeProps({ key: 1 }, _ctx.byReasonChart), null, 16))
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}